import React, { useRef } from 'react';
import { Grid, Box } from '@material-ui/core';
import { navigate } from 'gatsby';
import MailoIcon from '@material-ui/icons/MailOutline';
import SaveIcon from '@material-ui/icons/Save';
import PrinterIcon from '@material-ui/icons/Print';
import LinkIcon from '@material-ui/icons/Link';
import { saveAs } from 'file-saver';
import elementTemplateStyles from './DocumentFuncButtons.module.scss';
import '../../styles/basic_style.scss';
import DocRefDialog from '../DocumentMarcDisplayModal/DocumentReference';
import { marcToXml } from '../../utils/marc';

const DocumentFuncButtons = props => {
  let finalUrl = '';

  if (props.url[0] === '/') {
    finalUrl = (location.origin + props.url).toString();
  } else {
    finalUrl = props.url.toString();
  }

  const linkTooltipRef = useRef(null);

  const linkFunction = () => {
    const copyText = document.createElement('input');
    copyText.value = finalUrl;
    copyText.setAttribute('readonly', '');
    document.body.appendChild(copyText);
    copyText.select();
    document.execCommand('copy');
    document.body.removeChild(copyText);
    linkTooltipRef.current.innerHTML = 'Link sikeresen vágólapra másolva';
  };

  const linkFunctionMouseOutHandler = () => {
    linkTooltipRef.current.innerHTML = 'Link másolása';
  };

  /**
   * @type {{name: string; icon: React.ReactNode; attrs: JSX.IntrinsicElements['a']; tooltip?: string; tooltipAttrs?: JSX.IntrinsicElements["span"]}[]}
   */
  const functionalButtons = [
    /** @todo gomb visszarakása ha működik a funkció */
    // {
    //   name: 'E-mail',
    //   icon: <MailoIcon />,
    //   attrs: {
    //     onClick: () => {
    //       navigate(`${props.url}/mailto`);
    //     },
    //   },
    //   mailto: 'mailto:',
    // },
    {
      name: 'Mentés',
      icon: <SaveIcon />,
      attrs: {
        onClick: () => {
          saveAs(
            new Blob([marcToXml(props.data1)], { type: 'text/xml' }),
            'marcxml'
          );
        },
      },
      tooltip: 'Letöltés MARCXML formátumban',
    },
    {
      name: 'Nyomtatás',
      icon: <PrinterIcon />,
      attrs: {
        onClick: () => {
          navigate(`${props.url}/print`);
        },
      },
    },
    {
      name: 'Link',
      icon: <LinkIcon />,
      attrs: {
        onClick: linkFunction,
        onMouseOut: linkFunctionMouseOutHandler,
      },
      tooltip: 'Link másolása',
      tooltipAttrs: {
        ref: linkTooltipRef,
      },
    },
  ];

  return (
    <div className={'dataBox'}>
      <Box className={'docDataIconLinks'}>
        <Grid container direction="row">
          <Grid item className={'docDataLinkItem'}>
            <DocRefDialog data1={props.data1} />
          </Grid>

          {functionalButtons.map(functionalButton => (
            <Grid
              item
              className={'docDataLinkItem'}
              key={functionalButton.name}
            >
              <div className={elementTemplateStyles.tooltip}>
                <a
                  {...functionalButton.attrs}
                  className={elementTemplateStyles.functionButtons}
                >
                  <span className={'docDataLinkIcon'}>
                    {functionalButton.icon}
                  </span>
                  {functionalButton.tooltip && (
                    <span
                      {...functionalButton.tooltipAttrs}
                      className={elementTemplateStyles.tooltiptext}
                    >
                      {functionalButton.tooltip}
                    </span>
                  )}
                  <span>{functionalButton.name}</span>
                </a>
              </div>
            </Grid>
          ))}
        </Grid>
      </Box>
    </div>
  );
};

export default DocumentFuncButtons;
